import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import TagForm from '../TagForm/TagForm';
import { TAG_FORM_DEFAULT_VALUES } from '../TagForm/constants';
import { useModals } from 'hooks/useModals';
import { TTagsAdd } from './TagsAdd.types';
import { useAppDispatch } from 'store/store';
import {
  createTagAsyncThunk,
  getTagsListAsyncThunk,
} from 'store/tags/tags.action';
import { TTagFormValues } from '../TagForm/TagForm.types';

const TagsAdd: TTagsAdd = () => {
  const dispatch = useAppDispatch();
  const modals = useModals();

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: TAG_FORM_DEFAULT_VALUES,
  });

  const handleSubmit = (data: TTagFormValues) => {
    dispatch(
      createTagAsyncThunk({
        body: data,
        onSuccess: () => {
          modals.closeModal();
          dispatch(getTagsListAsyncThunk());
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <TagForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default TagsAdd;
